import * as React from 'react';

import { AlertMessageDTO } from 'root/apps/components/AlertMessageDisplay/AlertMessageDisplay';

export interface AlertMessageReturn {
  alertMessage: AlertMessageDTO | null;
  setAlertMessage: React.Dispatch<React.SetStateAction<AlertMessageDTO | null>>;
}

const defaultAlertMessageReturn: AlertMessageReturn = {
  alertMessage: null,
  setAlertMessage: () => Promise.reject<void>(new Error('setAlertMessage not initialized')),
};

export const AlertMessageContext =
  React.createContext<AlertMessageReturn>(defaultAlertMessageReturn);

const Provider: React.FC = ({ children }) => {
  const [alertMessage, setAlertMessage] = React.useState<AlertMessageDTO | null>(null);
  return (
    <AlertMessageContext.Provider
      value={{
        alertMessage,
        setAlertMessage,
      }}
    >
      {children}
    </AlertMessageContext.Provider>
  );
};

export default Provider;
